const state = {
  calls: []
};

export default {
  state
};
